import { formatDistanceToNow } from "date-fns";

export const prettyDate = (theDate: Date | null | string) => {
    if (theDate === null) return "";
    const myDate = new Date(theDate);
    let formattedDate = new Intl.DateTimeFormat('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
    }).format(myDate);
    return formattedDate;
}


export const prettyDateShort = (theDate: Date | null | string) => {
    if (theDate === null) return "";
    const myDate = new Date(theDate);
    let formattedDate = new Intl.DateTimeFormat('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    }).format(myDate);
    return formattedDate;
}

export const prettyDateTimeShort = (theDate: Date | null | string) => {
    if (theDate === null) return "";
    const myDate = new Date(theDate);
    let formattedDate = new Intl.DateTimeFormat('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
    }).format(myDate);
    return formattedDate;
}

export const formatDateTimeFromString = (date: string) => {
    var newDate = new Date(date);
    return new Intl.DateTimeFormat(undefined,{
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        timeZoneName: "short"
    }).format(newDate);
};

export const momentsAgo = (date: string) => {
    var newDate = new Date(date);
    return formatDistanceToNow(newDate);
};
